<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper blocked-account review-account">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>
    <form>
      <Card class="card-login">
        <img :src="hourglassImg">
        <h3>{{ $t('forms.otherAccount.workingAnother') }}</h3>
        <div class="row">
          <div class="col-12 blocked-account__text">
            {{ $t('forms.otherAccount.sessionRestarted') }}
          </div>
        </div>
        <a
          class="btn btn-primary btn-md"
          href="/"
        >
          {{ $t('forms.otherAccount.reloadWindow') }}
        </a>
      </Card>
    </form>
  </div>
</template>

<script>
import hourglassImg from '@/assets/theme/icon/hourglass.svg';

export default {
  computed: {
    hourglassImg: () => hourglassImg,
    logo() {
      return this.$config.layout.logoFull;
    },
  },
};
</script>
